import { useEffect, useRef, useState } from 'react';

type ReadMoreTextProps = {
    text: string;
    maxLines: number;
}

const ReadMoreText = ({ text, maxLines = 1 }: ReadMoreTextProps) => {
    const [isReadMore, setIsReadMore] = useState(true);
    const [isTruncated, setIsTruncated] = useState(false);
    const textRef = useRef(null) as any

    useEffect(() => {
        if ((typeof window) !== 'undefined' && !!window?.getComputedStyle) {
            const lineHeight = parseInt(window.getComputedStyle(textRef.current).lineHeight);
            const maxHeight = lineHeight * maxLines;
            const isTruncated = (textRef.current.scrollHeight - (maxLines - 1)) > maxHeight;
            setIsTruncated(isTruncated);
        }
    }, [maxLines, text]);

    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };

    if (!text) return null

    return (
        <div>
            <p
                ref={textRef}
                style={{
                    display: '-webkit-box',
                    WebkitLineClamp: isReadMore ? maxLines : 'unset',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                }}
                className='text-sm mb-0'
            >
                {text}
                {isTruncated && (
                    <u className="cursor-pointer font-semibold ms-2 text-xs" onClick={toggleReadMore}>{isReadMore ? 'Read More' : 'Read Less'}</u>
                )}
            </p>
            {(isTruncated && isReadMore) && (
                <u className="cursor-pointer font-semibold text-xs" onClick={() => setIsReadMore(false)}>Read More</u>
            )}
        </div>
    );
};

export default ReadMoreText;
